import {ChecklistStatus} from '@domain/hroc-checklists'
import {Check as CheckIcon, PlayCircleOutline as PlayCircleOutlineIcon} from '@mui/icons-material'
import {Chip, ChipOwnProps} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {HROC_CHECKLIST_STATUS_TRANSLATION_KEYS, HROC_CHECKLISTS_WIDGET_NAMESPACE} from '../consts'

export const ChecklistStatusChip = ({
  status,
  size
}: {
  status: ChecklistStatus
  size: ChipOwnProps['size']
}) => {
  const {t} = useTranslation(HROC_CHECKLISTS_WIDGET_NAMESPACE)

  return (
    <Chip
      label={t(HROC_CHECKLIST_STATUS_TRANSLATION_KEYS[status])}
      color={getChecklistStatusColor(status)}
      icon={getChecklistStatusIcon(status)}
      variant="outlined"
      size={size}
    />
  )
}

const getChecklistStatusColor = (status: ChecklistStatus) => {
  switch (status) {
    case ChecklistStatus.PENDING:
      return 'default'
    case ChecklistStatus.DONE:
      return 'success'
    default:
      return undefined
  }
}

const getChecklistStatusIcon = (status: ChecklistStatus) => {
  switch (status) {
    case ChecklistStatus.PENDING:
      return <PlayCircleOutlineIcon />
    case ChecklistStatus.DONE:
      return <CheckIcon />
    default:
      return undefined
  }
}
